export type ResponseFile = {
  id: string | number;
  url: string;
};

export type UploadFile = {
  file: File;
  id: string | number;
  responseFile?: ResponseFile | null;
};

export function transformFileToUploadFile(file: File): UploadFile {
  return {
    file,
    id: Date.now() * Math.round(Math.random() * 1000000),
  };
}

export function transformFilesToUploadFiles(files: File[]): UploadFile[] {
  return files.map(transformFileToUploadFile);
}
